// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"d45500b1","190":"0bef5cf1","370":"648b367e","511":"4aa5b2f8","750":"a276065a"}[chunkId] + ".chunk.js";
};